import React, { useState, useRef } from 'react'
import glamorous from 'glamorous'
import { css } from 'glamor'
import { HeadingText, BodyText, RadioButton, Link } from '@paypalcorp/pp-react'
import getContent from 'pp-react-l10n'
import { SELLER_SETTING_TYPES as types } from 'utils/constants'
import { showServiceError } from './../error/util'
import SaveButton from './shared/save-button'

const l10n = getContent('pages/seller/settings')

const Container = glamorous.div({
  display: 'flex',
  flexDirection: 'column',
})

const Heading = css({
  marginTop: 80,
  '@media(max-width: 414px)': {
    marginTop: 20,
  },
})

const SubHeading = css({
  textAlign: 'left',
  margin: '16px 0 20px',
})

const Legend = glamorous.span({
  border: 0,
  clip: 'rect(1px, 1px, 1px, 1px)',
  height: '1px',
  margin: '-1px',
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  width: '1px',
})

function EmailSetting(props) {
  const {
    sellerProfileState: {
      state: {
        sellerProfileDetails: {
          id: businessHandle = '',
          user_info: { display_email: email = '' } = {},
          privacy_settings: {
            email_search_enabled: searchEnabled = false,
          } = {},
        } = {},
      } = {},
    } = {},
  } = props
  const emailSearchEnabled = searchEnabled ? types.SHOW : types.HIDE
  const [value, setValue] = useState(emailSearchEnabled)
  const { editSellerSettings } = props.sellerProfileState
  const { current: initialValue } = useRef(value)
  const isChanged = value !== initialValue

  const handleChangeInput = (e) => {
    setValue(e.target.value)
  }

  const handleSave = async () => {
    const valueObj = [
      {
        op: 'replace',
        path: '/privacy_settings/email_search_enabled',
        value: value === types.SHOW,
      },
    ]

    try {
      await editSellerSettings(valueObj, businessHandle)
      props.history.push(`/seller/${businessHandle}/settings`)
    } catch (err) {
      showServiceError(err, props.history)
    }
  }

  const options = [
    {
      label: l10n('edit.email.option.show', { email }),
      value: types.SHOW,
    },
    {
      label: l10n('edit.email.option.hide', { email }),
      value: types.HIDE,
    },
  ]

  return (
    <Container>
      <HeadingText
        size="md"
        role="heading"
        aria-level="1"
        className={`${Heading}`}
      >
        {l10n('email')}
      </HeadingText>
      <BodyText className={`${SubHeading}`}>
        {/* TODO: Update links */}
        {l10n('primaryAccountInfo', {
          primaryAccountLink: (
            <Link to="/my/profile">{l10n('primaryAccountSettings')}</Link>
          ),
        })}
      </BodyText>
      <RadioButton
        name="email"
        label={<Legend>{l10n('email')}</Legend>}
        value={value}
        options={options}
        onChange={handleChangeInput}
      />
      {isChanged && <SaveButton handleSave={handleSave} />}
    </Container>
  )
}

export default EmailSetting
